import styled from '@emotion/styled';

export const Image = styled.img`
  margin: 2rem 2rem 2rem 1rem;
  max-width: 100%;
  width: 85%;

  object-fit: cover;
`;

export const Title = styled.h1`
  padding: 30px;
`;

export const SideNavContainer = styled.div`
  background-color: #43425d;
  color: #ffffff;
  margin: 0;
  max-width: 350px;
  min-width: 250px;
  width: 20%;
  overflow-x: hidden;
  overflow-y: auto;
`;

export const Divider = styled.hr`
  margin-top: 40px;
  margin-bottom: 40px;
`;

export const StyledList = styled.ul`
  list-style: none;
`;

export const StyledListItem = styled.li`
  display: flex;
  gap: 5px;
  padding: 10px;
  border-left-width: 5px;
  border-left-color: ${(props) => (props.border ? '#a3a0fb' : '#43425d')};
  border-left-style: solid;
  align-items: center;
  :hover {
    background-color: #3c3b54;
  }
`;
